@if (info) {
  <ion-row size="12" [style]="rowStyle" class="full_width"
    style="display: flex; align-items: center;line-height: 1.4; margin-top: 2%;">
    @if (icon) {
      <ion-col [size]="icon ? 1: 0">
        <ion-icon [color]="icon?.color ?? 'primary'" [name]="icon?.name ?? 'information-outline'"
          [size]="icon?.size ?? 'small'">
        </ion-icon>
      </ion-col>
    }
    <ion-col [size]="!icon ? 12: 11">
      @if ((info | typeof) !== 'string') {
        @for (line of info; track line) {
          <div [style]="line.lineStyle">
            {{ line.text }} @if (info.length > 1) {
            <br>
            }
          </div>
        }
      } @else {
        <div [style]="lineStyle">
          {{info}}
        </div>
      }
    </ion-col>
  </ion-row>
}
